module.exports = __webpack_public_path__ + "img/cases-brand-tommee-lazyload-31.2a4cbe6d.jpg";